import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom Proprietary Fertilizer specific variables
 */
export const parseProprietaryFertilizerEnvironment = (
  config: Record<string, string>,
): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Proprietary Fertilizer specific variables
  return {
    ...baseEnvironment,
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    FIELD_ADVICE_URL: config.FIELD_ADVICE_URL || '',
  };
};
